module.exports = __webpack_public_path__ + "site/img/118.762f2556.jpg";